import { render, staticRenderFns } from "./MkObjPopupTableInfo2.vue?vue&type=template&id=4fa99ac6&"
import script from "./MkObjPopupTableInfo2.vue?vue&type=script&lang=js&"
export * from "./MkObjPopupTableInfo2.vue?vue&type=script&lang=js&"
import style0 from "./MkObjPopupTableInfo2.vue?vue&type=style&index=0&id=4fa99ac6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports